module.exports = __webpack_public_path__ + "static/media/aaron.cf1f25d0.png";